export enum MessageAuthorType {
  Receiver = 'receiver',
  Sender = 'sender',
  System = 'system'
}
